import React, { useState } from 'react';
import { Card } from '../../../../../components/Card/Card';
import { Image } from '../../../../../model/asset';
import { t } from '../../../../../locales/translate';
import { Icon } from '../../../../../components/Icon/Icon';
import { Modal } from '../../../../../components/Modal/Modal';
import { EventImageModal } from './Modals/EventImageModal';

interface Props {
  product: {
    id: string;
    image?: Image | null;
    tourImage?: Image;
  };
}

export function EventImage({ product }: Props): JSX.Element {
  const [displayModal, setDisplayModal] = useState(false);

  const imageUrl = product.image ? product.image.url : product.tourImage?.url;
  return (
    <Card title={t.model.image._name} actions={<Icon name="edit" onClick={() => setDisplayModal(true)} />}>
      {imageUrl && (
        <a className="event-image__image" href={imageUrl} target="_blank" rel="noopener noreferrer">
          <img src={imageUrl} />
        </a>
      )}
      {!product.image && product.tourImage && <div>{t.model.event.displayingTourImage}</div>}
      <Modal open={displayModal} title={t.actions.edit(t.model.image._name)}>
        {() => <EventImageModal product={product} onClose={() => setDisplayModal(false)} />}
      </Modal>
    </Card>
  );
}
